import { useEffect, useRef } from 'react';
import { notification } from 'antd';
import actionCable from 'actioncable';

const buildCableUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'ws://localhost:5000/cable';
  }

  const onStaging = window.location.hostname === 'staging.medsender.com';
  const appUrl = onStaging ? 'staging.medsender.com' : 'app.medsender.com';
  return `wss://${appUrl}/cable`;
};

const usePortalNotifications = (onDocumentUploaded) => {
  const cableRef = useRef(null);
  const subscriptionRef = useRef(null);

  useEffect(() => {
    if (subscriptionRef.current) return undefined;

    cableRef.current = actionCable.createConsumer(buildCableUrl());

    subscriptionRef.current = cableRef.current.subscriptions.create(
      { channel: 'NotificationsChannel' },
      {
        received: (data) => {
          if (data.type === 'document_uploaded') {
            notification.info({
              message: 'New Document Shared',
              description: `${data.uploaded_by_org} shared a document on a referral`,
              duration: 5,
            });

            if (onDocumentUploaded) {
              onDocumentUploaded(data);
            }
          }
        },
      },
    );

    return () => {
      if (subscriptionRef.current) {
        subscriptionRef.current.unsubscribe();
        subscriptionRef.current = null;
      }
      if (cableRef.current) {
        cableRef.current.disconnect();
        cableRef.current = null;
      }
    };
  }, []);

  return null;
};

export default usePortalNotifications;
